module.exports = __webpack_public_path__ + "img/logo-hitbel.6af070ac.svg";